/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DashboardSummary_totalSales = {
    readonly yesterdaysSalesToDate: number;
    readonly currentMonthToDate: number;
    readonly lastMonthMonthToDate: number;
    readonly lastMonth: number;
    readonly " $refType": "DashboardSummary_totalSales";
};
export type DashboardSummary_totalSales$data = DashboardSummary_totalSales;
export type DashboardSummary_totalSales$key = {
    readonly " $data"?: DashboardSummary_totalSales$data;
    readonly " $fragmentRefs": FragmentRefs<"DashboardSummary_totalSales">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DashboardSummary_totalSales",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "yesterdaysSalesToDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentMonthToDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastMonthMonthToDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastMonth",
      "storageKey": null
    }
  ],
  "type": "DashboardCategorySales",
  "abstractKey": null
};
(node as any).hash = 'f0eab3a2e338f449d28e5ad72196a6e3';
export default node;
